module.exports = __webpack_public_path__ + "img/10.ad02a857.jpg";